// extracted by mini-css-extract-plugin
module.exports = {"root":"Timestamp-root-f0b3ebf43486d31ba5226a30c0e02f22","text":"Timestamp-text-b943991e0f8e51bb4bdba60eabe40535"};